import { InfoIcon } from "../Icons";
import './index.css'

interface AlertMessageProps {
    message: string
    severity?: 'info' | 'warning' | 'error'
}

const AlertMessage: React.FC<AlertMessageProps> = ({ message, severity = 'info' }) => {
    return (<div className={`alert-message-box ${severity}`}>
        {(severity === 'info') && (
            <InfoIcon className={`alert-message-box__icon ${severity}`} />
        )}
        {(severity === 'warning') && (
            <InfoIcon className={`alert-message-box__icon ${severity}`} />
        )}
        {(severity === 'error') && (
            <InfoIcon className={`alert-message-box__icon ${severity}`} />
        )}
        {message}

    </div>)

}

export default AlertMessage;